import React, { useState, useEffect, useContext, useCallback } from "react";
import moment from "moment";
import {
  ActionList,
  Button,
  Caption,
  DatePicker,
  Link,
  Modal,
  PageActions,
  Popover,
  RadioButton,
  Stack,
  Tabs,
  TextStyle,
} from "@shopify/polaris";
import { useLazyQuery } from "@apollo/react-hooks";
import { useQuery } from "react-apollo";

// import helper
import { baseHelper, errorHelper, statusHelper } from "lib/helpers";

import constant from "lib/constant/constant";

// import context
import { PrivateContext } from "lib/context";

// import queries
import { GET_PRODUCT_DETAILS } from "app/productOld/apollo/queries";

// import components
import { Banner } from "lib/components";
import List from "./subFeatures/list";

// import props
import { exportProps } from "./props";

const OperatorExportProduct = (props) => {
  const { openModal, setOpenModal, vendorData, bulkEditproduct = true } = props;
  const { cms, currentUser, history } = useContext(PrivateContext);
  const [isExportDone, setExportDone] = useState(false);
  const [queryData, setQueryData] = useState({});
  const [loading, setLoading] = useState(false);
  const dataToFetch = {};
  const [banner, setBanner] = useState({
    title: "",
    status: "",
    isOpen: false,
  });

  const { createdAt } = currentUser;
  const [
    getCheckProductList,
    { data: checkProductList, loading: checkProductLoading, error: checkProductError },
  ] = useLazyQuery(GET_PRODUCT_DETAILS, { variables: { input: queryData } });
  const { data: productData, loading: productLoading, error } = useQuery(GET_PRODUCT_DETAILS);

  const [selected, setSelected] = useState(0);
  const [vendorList, setVendorList] = useState([]);
  const [statusList, setStatusList] = useState([]);
  const [selectedItems, setSelectedItems] = useState([[], [], []]);
  const [submitDate, setSubmitDate] = useState({});
  const [generate, setGenerate] = useState(false);
  const [exportedAll, setExportedAll] = useState(true);
  const [exportedLink, setExportedLink] = useState(false);
  const [exportedPDFLink, setExportedPDFLink] = useState(false);
  const [isCalendarOpen, setIsCalendarOpen] = useState(false);
  const [isEnabled, setIsEnabled] = useState(false);
  const [active, setActive] = useState(false);
  const [popoverActive, setPopoverActive] = useState(false);

  const [{ month, year }, setDate] = useState({
    month: new Date().getMonth(),
    year: new Date().getFullYear(),
  });
  const [selectDate, setSelectDate] = useState();
  const [params, setParams] = useState();
  const exportProductURL = "/export/product";

  const disableDate = (newDate) => {
    if (newDate.getDate() === new Date(createdAt).getDate()) {
      newDate.setDate(new Date(createdAt).getDate() - 1);
    } else {
      newDate.setDate(new Date(createdAt));
    }
    return newDate;
  };

  const handleStates = () => {
    setExportedLink(null);
    setExportedPDFLink(null);
    setExportDone(false);
    setSelectedItems([[], [], []]);
    setSelected(0);
  };
  const handleMonthChange = useCallback((month, year) => setDate({ month, year }), []);
  useEffect(() => {
    if (error) {
      setBanner({ title: errorHelper.parse(error), status: constant.CRITICAL, isOpen: true });
      return;
    }
    if (!productLoading && !error && productData) {
      // let getVendor = [];
      let getStatus = [];
      const res = baseHelper.getResponseData(productData, constant.gql.GET_PRODUCT_DETAILS);

      if (!res.length && !(res.vendorData && res.vendorData.length)) {
        return;
      }

      res.productStatus.forEach((item) => {
        getStatus.push({
          id: item,
          name: statusHelper.getBadgeStatus(item),
        });
      });

      // res.vendorData.forEach((item) => {
      //   getVendor.push({
      //     id: item.vendorId,
      //     name: baseHelper.ucFirst(item.vendorName),
      //   });
      // });
      let getVendor = [];
      (vendorData || []).forEach((item) => {
        getVendor.push({
          id: item._id,
          name: item.brandName,
        });
      });

      getVendor = baseHelper.removeDuplicateData(getVendor);
      getStatus = baseHelper.removeDuplicateData(getStatus);
      getVendor = [...baseHelper.sort(getVendor, constant.NAME)];
      getStatus = [...baseHelper.sort(getStatus, constant.NAME)];
      setVendorList(getVendor);
      setStatusList(getStatus);
    }
  }, [productData, productLoading, error, vendorData]);

  useEffect(() => {
    let bannerData = false;
    if (checkProductList && !checkProductLoading && generate) {
      const checkProductData = baseHelper.getResponseData(checkProductList, constant.gql.GET_PRODUCT_DETAILS);
      const resError = baseHelper.getResponseError(checkProductList, constant.gql.GET_PRODUCT_DETAILS);
      if (!checkProductData.getProductDetailData.length) {
        bannerData = {
          title: resError || cms("section.export.message.error.noProduct"),
          status: constant.CRITICAL,
          isOpen: true,
        };
        setIsEnabled(true);
      }
      const csvDownloadRoute = `${exportProductURL}${params}`;
      const pdfDownloadRoute = `${exportProductURL}/pdf${params}`;
      setExportedLink((isExportDone && csvDownloadRoute) || null);
      setExportedPDFLink((isExportDone && pdfDownloadRoute) || null);
      setLoading(false);
    }
    if (checkProductError) {
      bannerData = { title: errorHelper.parse(checkProductError), status: constant.CRITICAL, isOpen: true };
    }
    if (bannerData) {
      setBanner({ title: bannerData.title, status: bannerData.status, isOpen: bannerData.isOpen });
      handleStates();
    }
  }, [checkProductError, checkProductList, checkProductLoading, exportedAll, isExportDone, params, cms]);

  const handleTabChange = (selectedTabIndex) => {
    setSelected(selectedTabIndex);
    setExportedLink(null);
    setExportedPDFLink(null);
    setExportDone(false);
  };

  const onExport = () => {
    setLoading(true);
    setGenerate(true);
    const dateRange = selectDate || {};
    let status = [];
    let vendor = [];
    vendor = [...selectedItems[0]];
    status = [...selectedItems[1]];
    const vendorString = vendor.join(",");
    const statusString = status.join(",");

    if (!(exportedAll || vendorString || statusString)) {
      setLoading(false);
      setBanner({ title: cms("section.export.message.error.select"), status: constant.CRITICAL, isOpen: true });
      return;
    }
    let url = `?startDate=${dateRange.start || ""}&endDate=${dateRange.end || ""}`;
    if (!exportedAll) {
      url = `?vendor=${vendorString}&status=${statusString}&startDate=${dateRange.start || ""}&endDate=${
        dateRange.end || ""
      }`;
    }
    setParams(url);

    if (status.length > 0) {
      dataToFetch.status = status;
    }
    if (vendor.length > 0) {
      dataToFetch.vendor = vendor;
    }
    if (selectDate) {
      const startDate = moment(selectDate.start).format("ll");
      const endDate = moment(selectDate.end).format("ll");
      dataToFetch.dateRange = { start: startDate, end: endDate };
    }

    setQueryData(dataToFetch);
    getCheckProductList();
    setExportedLink(false);
    setExportedPDFLink(false);
    setExportDone(true);
  };

  const tabs = [
    { id: "vendors", content: cms("section.export.label.vendor"), panelId: "panel-vendor" },
    { id: "statuses", content: cms("section.export.label.status"), panelId: "panel-status" },
  ];

  const getResourceListTabs = () => {
    const exportModalTabs = baseHelper.cloneData(tabs);
    const singularItem = constant.ITEM;
    const pluralItem = constant.ITEMS;
    const changeIndex = 0;
    selectedItems.forEach((item, index) => {
      if (item.length > 0) {
        exportModalTabs[index + changeIndex].content += ` (${item.length} ${
          item.length === 1 ? singularItem : pluralItem
        } ${constant.SELECTED})`;
      }
    });
    return exportModalTabs;
  };

  const items = [vendorList, statusList];
  const handleSelection = (event) => {
    const prevSelection = [...selectedItems];
    prevSelection[selected] = [...event];
    setSelectedItems(prevSelection);
    setExportedLink(null);
    setExportedPDFLink(null);
    setExportDone(false);
    setLoading(false);
  };

  const onCloseModal = () => {
    handleStates();
    setExportedAll(true);
    setOpenModal(false);
    setBanner("");
    setLoading(false);
    setSubmitDate({});
    setSelectDate();
    setIsCalendarOpen(false);
    setGenerate(false);
    setIsEnabled(false);
    setActive(false);
    setPopoverActive(false);
  };

  const onDismissBanner = () => {
    setIsEnabled(false);
    setExportedLink(false);
    setBanner({ isOpen: !banner.isOpen });
  };

  const downloadCSV = (link) => {
    window.open(link);
    onCloseModal();
  };

  const downloadPDF = (link) => {
    window.open(link);
    onCloseModal();
  };

  const tab = getResourceListTabs();

  const handleChange = () => {
    setActive(!active);
    setPopoverActive(!popoverActive);
  };

  const activator = (
    <Button onClick={handleChange} disclosure>
      {cms("section.export.label.selectFormat")}
    </Button>
  );
  const togglePopoverActive = useCallback(() => setPopoverActive(!popoverActive), [popoverActive]);

  const handleDatePicker = () => {
    setIsEnabled(banner.isOpen);
    setExportedLink(false);
    setSelectDate({ start: selectDate.start, end: selectDate.end });
    setSubmitDate((prev) => {
      const initialState = { ...prev };
      initialState.start = selectDate.start;
      initialState.end = selectDate.end;
      initialState.startingDate = moment(selectDate.start).format("ll");
      initialState.endingDate = moment(selectDate.end).format("ll");
      initialState.isShowDate = true;
      return initialState;
    });
    setIsCalendarOpen(false);
  };

  const handleCancelDate = () => {
    const initialState = { ...submitDate };
    setSelectDate({
      start: initialState.start || new Date(),
      end: initialState.end || new Date(),
    });
    setIsCalendarOpen(false);
    setIsEnabled(banner.isOpen);
    setExportedLink(false);
  };

  const actionOption = [
    {
      content: cms("section.export.label.exportCSV"),
      onAction: () => {
        setLoading(false);
        downloadCSV(exportedLink);
      },
    },
  ];
  if (bulkEditproduct) {
    actionOption.push({
      content: cms("section.export.label.exportPDF"),
      onAction: () => {
        setLoading(false);
        downloadPDF(exportedPDFLink);
      },
    });
  }
  const handlePopover = () => {
    return (
      <Popover active={popoverActive} activator={activator} onClose={togglePopoverActive}>
        <ActionList items={actionOption} />
      </Popover>
    );
  };

  const actions = () => (
    <Stack alignment="center">
      <Stack.Item fill>
        <Link onClick={() => history.push("/setting/product/export")}>{cms("section.export.label.customize")}</Link>
      </Stack.Item>
      <Stack.Item>
        <Button onClick={() => onCloseModal()}>{cms("section.export.label.cancel")}</Button>
      </Stack.Item>
      <Stack.Item>
        {exportedLink && !isEnabled ? (
          handlePopover()
        ) : (
          <Button primary onClick={() => onExport()} loading={loading} disabled={isEnabled}>
            {cms("section.export.label.generate")}
          </Button>
        )}
      </Stack.Item>
    </Stack>
  );

  return (
    <Modal
      open={openModal}
      onClose={() => onCloseModal()}
      title={cms("section.export.label.title")}
      loading={productLoading}
      footer={actions()}
    >
      <Banner title={banner.title} status={banner.status} isOpen={banner.isOpen} onDismiss={() => onDismissBanner()} />
      <Modal.Section>
        {isCalendarOpen && (
          <>
            <div>
              <DatePicker
                month={month}
                year={year}
                onChange={(date) => {
                  setSelectDate({ start: date.start, end: date.end });
                }}
                onMonthChange={handleMonthChange}
                selected={selectDate}
                disableDatesAfter={new Date()}
                disableDatesBefore={disableDate(new Date(moment(createdAt).format()))}
                multiMonth
                allowRange
              />
            </div>
            <div>
              <PageActions
                primaryAction={{
                  content: cms("section.export.label.apply"),
                  onClick: () => {
                    handleDatePicker();
                    setIsEnabled(false);
                  },
                }}
                secondaryActions={[
                  {
                    content: cms("button.cancel"),
                    onClick: () => {
                      handleCancelDate();
                      setIsEnabled(false);
                    },
                  },
                ]}
              />
            </div>
            <br />
          </>
        )}
        {!isCalendarOpen && (
          <Stack>
            <Stack.Item fill>
              <RadioButton
                id="exportAllRadio"
                name={constant.EXPORT}
                label={cms("section.export.label.all")}
                helpText={cms("section.export.helpText.all")}
                checked={exportedAll}
                onChange={() => {
                  setBanner({ isOpen: false });
                  setExportedAll(!exportedAll);
                  setExportDone(false);
                  setExportedPDFLink(false);
                  setExportedLink(false);
                  setGenerate(false);
                  setIsEnabled(false);
                }}
              />
            </Stack.Item>
            <Stack.Item>
              <Button
                plain
                removeUnderline
                onClick={() => {
                  setIsCalendarOpen(true);
                  setIsEnabled(true);
                }}
              >
                {cms("section.export.label.date")}
              </Button>
              {submitDate.isShowDate && (
                <TextStyle variation="subdued">
                  <Caption>{`${submitDate.startingDate} - ${submitDate.endingDate}`}</Caption>
                </TextStyle>
              )}
            </Stack.Item>
            <RadioButton
              id="exportSelectedRadio"
              name={constant.EXPORT}
              label={cms("section.export.label.one")}
              helpText={cms("section.export.helpText.select")}
              checked={!exportedAll}
              onChange={() => {
                setBanner({ isOpen: false });
                setExportedAll(!exportedAll);
                setExportDone(false);
                setExportedPDFLink(false);
                setExportedLink(false);
                setGenerate(false);
                setIsEnabled(false);
              }}
            />
          </Stack>
        )}
        {!exportedAll && !isCalendarOpen && (
          <Tabs tabs={tab} selected={selected} onSelect={handleTabChange} fitted>
            <List
              items={items}
              selected={selected}
              handleSelection={handleSelection}
              productLoading={productLoading}
              selectedItems={selectedItems || []}
              onExport={onExport}
              cms={cms}
            />
          </Tabs>
        )}
      </Modal.Section>
    </Modal>
  );
};

OperatorExportProduct.propTypes = exportProps.type;
OperatorExportProduct.defaultProps = exportProps.default;

export default OperatorExportProduct;
